export const LABELS = {
  GRANT_TYPE: {
    PASSWORD: 'password',
    CLIENT_CREDENTIALS: 'client_credentials',
    REFRESH_TOKEN: 'refresh_token',
  },
};

export const SESSION_KEYS = {
  LOGIN_RES: '_LOGIN_RES',
  DEFAULT_BIZ_CODE: 'DEFAULT_BIZ_CODE',
  KIOSK_MODE: 'KIOSK_MODE',
};
